import React, { useEffect } from 'react';
import { Result, Spin } from 'antd';
import { onBlankLayout } from 'store/slices/themeSlice';
import { useDispatch } from 'react-redux';
import useAccessProfile from 'hooks/useAccessProfile';
import { useTranslation } from 'react-i18next';
import { canAccessNavKey } from 'auth/permissions';

const AppRoute = ({ component: Component, routeKey, blankLayout, ...props }) => {

	const { t } = useTranslation()
	const dispatch = useDispatch()
	const { profile, loading } = useAccessProfile()
	const publicAuthRoutes = ['login', 'register', 'forgot-password']
	const isPublicAuthRoute = publicAuthRoutes.includes(routeKey)

	useEffect(() => {
		const isBlank = blankLayout ? true : false
		dispatch(onBlankLayout(isBlank))

	}, [blankLayout])
	const accessKey = routeKey === 'campaign-detail' ? 'campaigns' : routeKey;
	if (!blankLayout && !isPublicAuthRoute && loading) return <div style={{ minHeight: 220, display: 'grid', placeItems: 'center' }}><Spin /></div>
	if (!blankLayout && !isPublicAuthRoute && accessKey && !canAccessNavKey(profile, accessKey)) {
		return <Result status="403" title={t('route.forbiddenTitle')} subTitle={t('route.forbiddenDescription')} />
	}

	return (
		<Component {...props} />
	)
}

export default AppRoute